<template>
  <pl-dialog
    size="relative"
    :title="isToEditSubmission ? 'Update Suggestion' : 'Add Suggestion'"
    @close="$emit('close')"
    :disableOutsideClick="true"
  >
    <div v-if="isToEditSubmission === false" class="flex justify-center">
      <div class="flex justify-center mt-10 mb-4">
        <i class="fa-solid fa-circle-plus text-4xl text-primary"></i>
      </div>
    </div>
    <p v-if="isToEditSubmission === false" class="text-center px-32 text-gray-800 mb-5">
      After adding new suggestion you can use on all students or import later to
      another course.
    </p>
    <textarea
      v-model="suggestion"
      :rows="isToEditSubmission === true ? 11 : 6"
      class="bg-gray-100 rounded mx-6 outline-none px-6 py-4"
      placeholder="Write a new Suggestion"
      :class="isToEditSubmission === true ? 'mt-6' : ''"
    />
    <div v-if="isToEditSubmission" class="flex justify-center items-center mt-6 mx-6">
      <input
        type="checkbox"
        class="cursor-pointer"
        v-model="isToApplySuggestion"
      />
      <span class="ml-2 text-sm">Apply sugestion after update</span>
    </div>
    <div class="flex justify-center my-6">
      <button @click="$emit('openMySuggestionsModal')" class="bg-gray-100 rounded px-5 py-2 mr-3">
        Cancel
      </button>
      <button @click=" isToEditSubmission === true ? editSuggestion() : createSuggestion()" \class="sample px-5 py-2 bg-primary rounded text-white">
        {{ isToEditSubmission === true ? 'Update Suggestion' : 'Add Suggestion' }}
      </button>
    </div>
  </pl-dialog>
</template>
<script>
  import Vue from 'vue';
  import { mapGetters } from 'vuex';
  import { EventBus } from '../../../../utils/event-bus';
  export default Vue.extend({
    data() {
      return {
        suggestion: '',
        isToEditSubmission: false,
        isToApplySuggestion: false,
      };
    },
    props: {
      typeRoundTable: {
        type: String,
        default: '',
      },
      suggestionToEdit: {
        type: String,
      },
    },
    computed: {
      ...mapGetters(['getCourseDetail']),
    },
    methods: {
      editSuggestion: function () {
        const courseID = this.$route.params.courseID;
        const propertiesSuggestion = {
          course_id: courseID,
          feedback_id: this.suggestionToEdit.id,
          text: this.suggestion,
          roundtable_type: 'live',
        };
        this.$store
          .dispatch('updateFeedback', propertiesSuggestion)
          .then(() => {
            const toast = {
              type: 'Success',
              message: 'Suggestion edit was successfuly!',
              time: 5000,
            };
            this.$emit('close');
            this.$emit('cleanSuggestionTo');
            this.isToApplySuggestion === true
              ? this.$emit('getNewSuggestion', this.suggestion)
              : '';
            EventBus.$emit('createToast', toast);
          })
          .catch(console.error);
      },
      createSuggestion: function () {
        const courseID = this.$route.params.courseID;
        this.$store
          .dispatch('saveFeedback', {
            course_id: courseID,
            text: this.suggestion,
            roundtable_type: 'live',
          })
          .then(() => {
            const toast = {
              type: 'Success',
              message: 'Suggestion is created!',
              time: 5000,
            };
            this.$emit('close');
            this.$emit('getNewSuggestion', this.suggestion);
            this.$emit('cleanSuggestionTo');
            EventBus.$emit('createToast', toast);
          })
          .catch(console.error);
      },
    },
    mounted() {
      this.isToEditSubmission = false;
      if (this.suggestionToEdit)
        return (
          (this.suggestion = this.suggestionToEdit.text),
          (this.isToEditSubmission = true)
        );
    },
  });
</script>
<style scoped>
  input[type='checkbox'] {
    width: 1.25rem !important;
    height: 1.25rem !important;
    -webkit-appearance: none;
    -moz-appearance: none;
    -o-appearance: none;
    appearance: none;
    box-shadow: none;
    font-size: 0.8rem;
    text-align: center;
    line-height: 1.25rem;
    border-radius: 0.25rem;
    --tw-bg-opacity: 1;
    background-color: rgba(243, 244, 246, var(--tw-bg-opacity));
  }
  input[type='checkbox']:checked {
    background-color: #72ccd7;
  }
  input[type='checkbox']:checked::after {
    font-family: 'Font Awesome 5 Free';
    content: '\f00c';
    font-weight: 900;
    color: white;
    line-height: 1.25rem;
  }
</style>



// WEBPACK FOOTER //
// NewSuggestionFeedback.vue?1d66cfe8